<span class="sz-score-chip">
  <span class="sz-score-chip__label">{{ label() }}</span>
</span>
